/* unplugin-vue-components disabled */import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/esnext.async-iterator.filter.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import { useCreditStore } from '@/stores/modules/credit';
import { useUserStore } from '@/stores/modules/user';
import objToArray from '@/shared/objToArray';
import yxhJsBridge from '@/shared/yxhJsBridge';
import base64 from '@/shared/base64';
import { Toast } from 'vant';
import TrackingData from '@/shared/reportDataTracking';
import SelectPopup from '@/components/select-popup.vue';
import { useCreditCommon, useFormTracking, useRetainPopup } from '@/composables/useCreditCommon.js';
// use composables
export default {
    __name: 'idMessage',
    setup: function(__props) {
        var _useCreditCommon = useCreditCommon(), agreed = _useCreditCommon.agreed, enterTime = _useCreditCommon.enterTime, PrivacyDataBox = _useCreditCommon.PrivacyDataBox;
        var _useFormTracking = useFormTracking(), focusDataMap = _useFormTracking.focusDataMap, onClosePopupTrack = _useFormTracking.onClosePopupTrack, onFocusTrack = _useFormTracking.onFocusTrack, onBlurTrack = _useFormTracking.onBlurTrack;
        var _useRetainPopup = useRetainPopup(), CreditFirstRetainPopup = _useRetainPopup.CreditFirstRetainPopup, CreditSecondRetainPopup = _useRetainPopup.CreditSecondRetainPopup, isShowFirstRetainPopup = _useRetainPopup.isShowFirstRetainPopup, isShowSecondRetainPopup = _useRetainPopup.isShowSecondRetainPopup, showSecondRetainPopup = _useRetainPopup.showSecondRetainPopup, goAppHome = _useRetainPopup.goAppHome;
        var router = useRouter();
        var creditStore = useCreditStore();
        var userStore = useUserStore();
        var idNo = ref('');
        var fullName = ref('');
        var codeSex = ref('');
        var textSex = ref('');
        var columnsSex = ref([]);
        var showPickerSex = ref(false);
        var onFocusTrackID = function(str) {
            onFocusTrack(str);
            switch(str){
                case 'ID_number':
                    focusDataMap.value[str] = idNo.value;
                    break;
                case 'name':
                    focusDataMap.value[str] = fullName.value;
                    break;
                case 'expiry_date':
                    focusDataMap.value[str] = dueDate.value;
                    break;
            }
        };
        var onBlurTrackID = function(str) {
            var taskState = 0;
            switch(str){
                case 'ID_number':
                    taskState = Number(focusDataMap.value[str] !== idNo.value);
                    break;
                case 'name':
                    taskState = Number(focusDataMap.value[str] !== fullName.value);
                    break;
                case 'expiry_date':
                    taskState = Number(focusDataMap.value[str] !== dueDate.value);
                    break;
            }
            onBlurTrack(str, taskState);
        };
        var onConfirmSex = function(value) {
            var taskState = (value === null || value === void 0 ? void 0 : value.mainLock) === codeSex.value ? 0 : 1;
            codeSex.value = value === null || value === void 0 ? void 0 : value.mainLock;
            textSex.value = value === null || value === void 0 ? void 0 : value.worthValue;
            showPickerSex.value = false;
            console.log('gender taskState', value, taskState);
            onClosePopupTrack('gender', taskState);
        };
        var initData = function(dictionary) {
            columnsSex.value = objToArray(dictionary.dataMap.sexType);
        };
        onBeforeMount(function() {
            if (creditStore.dictionary) {
                initData(creditStore.dictionary);
            }
        });
        watch(function() {
            return creditStore.dictionary;
        }, function(newVal) {
            if (newVal) {
                initData(newVal);
            }
        }, {
            immediate: true
        });
        var birthday = ref('');
        var defaultDate = ref(new Date());
        var showPickerBirthday = ref(false);
        var minDate = computed(function() {
            var now = new Date();
            var year = now.getFullYear() - 60;
            return new Date(year, 0, 31);
        });
        var maxDate = computed(function() {
            var now = new Date();
            var year = now.getFullYear() - 18;
            return new Date(year, 11, 31);
        });
        var onConfirmBirthday = function(day) {
            var date = "".concat(day.getDate().toString().padStart(2, '0'), "/").concat((day.getMonth() + 1).toString().padStart(2, '0'), "/").concat(day.getFullYear());
            var taskState = date === birthday.value ? 0 : 1;
            showPickerBirthday.value = false;
            birthday.value = date;
            console.log('birthday taskState', date, taskState);
            onClosePopupTrack('birthday', taskState);
        };
        var dueDate = ref('');
        var idImgSrc = ref();
        var clickUploadTime = ref();
        var uploadIDcard = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    idImgSrc.value = null;
                    idNo.value = '';
                    fullName.value = '';
                    codeSex.value = '';
                    textSex.value = '';
                    birthday.value = '';
                    dueDate.value = '';
                    clickUploadTime.value = new Date();
                    TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                        taskHandler: 'id_info_screen_upload-click'
                    }));
                    yxhJsBridge.takeOcrPhoto();
                    window.ocrSuc = /*#__PURE__*/ function() {
                        var _ref = _async_to_generator(function(val) {
                            var params, _tmp, _arr_, resultInfo, arr, _resultInfo_userBirth_split, day, month, year, error;
                            return _ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _tmp = {};
                                        return [
                                            4,
                                            base64(val)
                                        ];
                                    case 1:
                                        params = (_tmp.imageData = _state.sent(), _tmp.textScan = 0, _tmp.dealCode = '', _tmp.identityCode = 1, _tmp);
                                        _state.label = 2;
                                    case 2:
                                        _state.trys.push([
                                            2,
                                            4,
                                            ,
                                            5
                                        ]);
                                        return [
                                            4,
                                            creditStore.reqOcrResult(params)
                                        ];
                                    case 3:
                                        resultInfo = _state.sent();
                                        TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                                            taskHandler: 'id_info_screen_upload-finish',
                                            taskState: 1,
                                            growArea: JSON.stringify({
                                                msg: 'pass'
                                            }),
                                            eventIntervalSpan: new Date() - clickUploadTime.value
                                        }));
                                        console.log(resultInfo, 'reqOcrResult');
                                        if (resultInfo.winStatus === 0) {
                                            TrackingData.trackIdentify(_object_spread_props(_object_spread({}, userStore.commonData), {
                                                taskHandler: 'id_info_screen-ocr_result',
                                                taskState: 0,
                                                growArea: JSON.stringify({
                                                    msg: resultInfo.errorCause
                                                })
                                            }));
                                            Toast(resultInfo.errorCause);
                                            return [
                                                2
                                            ];
                                        }
                                        TrackingData.trackIdentify(_object_spread_props(_object_spread({}, userStore.commonData), {
                                            taskHandler: 'id_info_screen-ocr_result',
                                            taskState: 1,
                                            growArea: JSON.stringify({
                                                msg: 'pass'
                                            })
                                        }));
                                        idImgSrc.value = val;
                                        idNo.value = resultInfo.identityKey;
                                        fullName.value = resultInfo.sureName;
                                        codeSex.value = resultInfo.sexType;
                                        arr = columnsSex.value.filter(function(item) {
                                            return item.mainLock === String(codeSex.value);
                                        });
                                        textSex.value = (_arr_ = arr[0]) === null || _arr_ === void 0 ? void 0 : _arr_.worthValue;
                                        birthday.value = resultInfo.userBirth;
                                        _resultInfo_userBirth_split = _sliced_to_array(resultInfo.userBirth.split('/'), 3), day = _resultInfo_userBirth_split[0], month = _resultInfo_userBirth_split[1], year = _resultInfo_userBirth_split[2];
                                        defaultDate.value = new Date(year, month - 1, day);
                                        dueDate.value = resultInfo.idExpire;
                                        return [
                                            3,
                                            5
                                        ];
                                    case 4:
                                        error = _state.sent();
                                        TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                                            taskHandler: 'id_info_screen_upload-finish',
                                            taskState: 0,
                                            growArea: JSON.stringify({
                                                msg: error.message
                                            }),
                                            eventIntervalSpan: new Date() - clickUploadTime.value
                                        }));
                                        return [
                                            3,
                                            5
                                        ];
                                    case 5:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(val) {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    window.ocrError = function(val) {
                        console.log(val, 'ocrError');
                        Toast(val);
                    };
                    return [
                        2
                    ];
                });
            });
            return function uploadIDcard() {
                return _ref.apply(this, arguments);
            };
        }();
        var onSubmit = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(value) {
                var params, _tmp, routeObj;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!idImgSrc.value) {
                                TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                                    taskHandler: 'id_info_screen-submit',
                                    taskState: 0,
                                    eventIntervalSpan: Date.now() - enterTime.value
                                }));
                                Toast('Cargue una foto de su INE/IFE');
                                return [
                                    2
                                ];
                            }
                            TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                                taskHandler: 'id_info_screen-submit',
                                taskState: 1,
                                eventIntervalSpan: Date.now() - enterTime.value
                            }));
                            console.log('submit idMessage', value);
                            _tmp = {
                                identityKey: idNo.value,
                                sureName: fullName.value,
                                sexType: codeSex.value,
                                userBirth: birthday.value,
                                idExpire: dueDate.value,
                                identityCode: 1
                            };
                            return [
                                4,
                                base64(idImgSrc.value)
                            ];
                        case 1:
                            params = (_tmp.idPic = _state.sent(), _tmp);
                            return [
                                4,
                                creditStore.reqOcrSubmit(params)
                            ];
                        case 2:
                            routeObj = _state.sent();
                            if ((routeObj === null || routeObj === void 0 ? void 0 : routeObj.path) !== '/idMessage') {
                                router.push(routeObj);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function onSubmit(value) {
                return _ref.apply(this, arguments);
            };
        }();
        var onFailed = function() {
            TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                taskHandler: 'id_info_screen-submit',
                taskState: 0,
                eventIntervalSpan: Date.now() - enterTime.value
            }));
        };
        onUnmounted(function() {
            window.ocrSuc = function() {};
            window.ocrError = function() {};
        });
        return {
            __sfc: true,
            agreed: agreed,
            enterTime: enterTime,
            PrivacyDataBox: PrivacyDataBox,
            focusDataMap: focusDataMap,
            onClosePopupTrack: onClosePopupTrack,
            onFocusTrack: onFocusTrack,
            onBlurTrack: onBlurTrack,
            CreditFirstRetainPopup: CreditFirstRetainPopup,
            CreditSecondRetainPopup: CreditSecondRetainPopup,
            isShowFirstRetainPopup: isShowFirstRetainPopup,
            isShowSecondRetainPopup: isShowSecondRetainPopup,
            showSecondRetainPopup: showSecondRetainPopup,
            goAppHome: goAppHome,
            router: router,
            creditStore: creditStore,
            userStore: userStore,
            idNo: idNo,
            fullName: fullName,
            codeSex: codeSex,
            textSex: textSex,
            columnsSex: columnsSex,
            showPickerSex: showPickerSex,
            onFocusTrackID: onFocusTrackID,
            onBlurTrackID: onBlurTrackID,
            onConfirmSex: onConfirmSex,
            initData: initData,
            birthday: birthday,
            defaultDate: defaultDate,
            showPickerBirthday: showPickerBirthday,
            minDate: minDate,
            maxDate: maxDate,
            onConfirmBirthday: onConfirmBirthday,
            dueDate: dueDate,
            idImgSrc: idImgSrc,
            clickUploadTime: clickUploadTime,
            uploadIDcard: uploadIDcard,
            onSubmit: onSubmit,
            onFailed: onFailed,
            SelectPopup: SelectPopup
        };
    }
};
